import React from "react";
import type { MenuProps } from "antd";
import { Layout, Menu } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { RiContactsBook2Fill } from "react-icons/ri";
import { FaChartPie, FaInfoCircle } from "react-icons/fa";
import { AiFillSetting } from "react-icons/ai";
import { FaUserCircle } from "react-icons/fa";

const { Sider } = Layout;

export type MenuItem = Required<MenuProps>["items"][number];

export function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[]
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
  } as MenuItem;
}

export const items: MenuItem[] = [
  getItem("Dashboard", "", <FaChartPie />),
  getItem("User Management", "usermanagement", <FaUserCircle />, [
    // getItem("Menu", "menu"),
    // getItem("Rights", "rights"),
    getItem("User Type", "usertype"),
    getItem("User", "user"),
  ]),
  getItem("Masters", "masters", <AiFillSetting />, [
    getItem("Country", "country"),
    getItem("State", "state"),
    getItem("City", "city"),
    getItem("Region", "region"),
    getItem("Sector", "sector"),
    getItem("Speciality Type", "specialitytype"),
    getItem("Vehicle Sharing Pax", "vehiclesharingpax"),
    getItem("Itinerary", "itinerary"),
    getItem("Itinerary Facility", "itineraryfacility"),
    getItem("Room Type", "roomtype"),
    getItem("Hotel", "hotel"),
    getItem("Add Tour", "tour"),
    getItem("Currency", "currency"),
    getItem("Company", "company"),
    // getItem("Festivals", "festivals"),
    getItem("GST", "gst"),
    getItem("Our Expertise", "ourexpertise"),
    getItem("Web Branch", "webbranch"),
    getItem("Banner", "banner"),
    getItem("CMS", "cms"),
    getItem("Seo Tag", "seotag"),
    getItem("Blog", "blog"),
    getItem("Testimonial", "testimonial"),
    getItem("Service", "service"),
    getItem("FAQ", "faq"),
    // getItem("Useful Links", "usefullinks"),
    getItem("Setting", "setting"),
    getItem("Client", "client"),
  ]),
  getItem("About", "about", <FaInfoCircle />),
  getItem("Inquiries", "inquiries", <RiContactsBook2Fill />),
];

interface HeaderProps {
  collapsed: boolean;
  setCollapsed: (value: boolean) => void;
}

const Header: React.FC<HeaderProps> = ({ collapsed, setCollapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const onClick: MenuProps["onClick"] = (e) => {
    navigate(e.key);
  };

  const userResponseString = localStorage.getItem("UserRightsAssign") || "[]";
  let userResponse: {
    MenuID: number;
    MenuKey: string;
    MenuName: string;
    RightsID: string;
  }[];

  try {
    userResponse = JSON.parse(userResponseString);
  } catch (error) {
    userResponse = [];
  }

  const allowedKeys = new Set(userResponse.map((item) => item.MenuKey));

  function filterMenuItems(menuItems: MenuItem[]): MenuItem[] {
    return menuItems.reduce((filteredItems, item: any) => {
      if (allowedKeys.has(item.key)) {
        if (item.children) {
          const filteredChildren = filterMenuItems(item.children);
          filteredItems.push({ ...item, children: filteredChildren });
        } else {
          filteredItems.push(item);
        }
      } else if (item.children) {
        const filteredChildren = filterMenuItems(item.children);
        if (filteredChildren.length > 0) {
          filteredItems.push({ ...item, children: filteredChildren });
        }
      }
      return filteredItems;
    }, [] as MenuItem[]);
  }

  let filteredItems = filterMenuItems(items);

  const hasDashboardAccess = userResponse.some(
    (item) => item.MenuKey === "dashboard"
  );
  if (hasDashboardAccess) {
    filteredItems = [
      getItem("Dashboard", "", <FaChartPie />),
      ...filteredItems,
    ];
  }

  function mapToGetItemFormat(menuItems: MenuItem[]): MenuItem[] {
    return menuItems.map((item: any) =>
      getItem(
        item.label,
        item.key,
        item.icon,
        item.children ? mapToGetItemFormat(item.children) : undefined
      )
    );
  }

  const formattedItems = mapToGetItemFormat(filteredItems);

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
    >
      <div className="drawer-logo">
        <h3 style={{ textAlign: "center", color: "#fff", margin: 0 }}>ST</h3>
      </div>
      <Menu
        className="sider-scroll"
        style={{
          overflow: "auto",
          height: "calc(100vh - 115px)",
        }}
        onClick={onClick}
        theme="dark"
        defaultSelectedKeys={[""]}
        selectedKeys={[location.pathname?.substring(1)?.split("/")[0]]}
        mode="inline"
        items={formattedItems}
        // items={items}
      />
    </Sider>
  );
};

export default Header;
